import DemoSection from '../DemoSection';
import { UIBadge } from '../WebComponents';

export default function BadgeDemo() {
  return (
    <DemoSection title="Badge 徽章" description="图标右上角的红点、数字或者文字">
      <DemoSection.Item title="样式变体">
        <div className="demo-content">
          <UIBadge variant="primary">主要</UIBadge>
          <UIBadge variant="secondary">次要</UIBadge>
          <UIBadge variant="outline">轮廓</UIBadge>
          <UIBadge variant="glow">发光</UIBadge>
        </div>
        <div className="code-block">
          <code>{`<UIBadge variant="primary">主要</UIBadge>
<UIBadge variant="secondary">次要</UIBadge>
<UIBadge variant="outline">轮廓</UIBadge>
<UIBadge variant="glow">发光</UIBadge>`}</code>
        </div>
      </DemoSection.Item>

      <DemoSection.Item title="尺寸">
        <div className="demo-content">
          <UIBadge variant="primary" size="small">小</UIBadge>
          <UIBadge variant="primary" size="medium">中</UIBadge>
          <UIBadge variant="primary" size="large">大</UIBadge>
        </div>
        <div className="code-block">
          <code>{`<UIBadge variant="primary" size="small">小</UIBadge>
<UIBadge variant="primary" size="medium">中</UIBadge>
<UIBadge variant="primary" size="large">大</UIBadge>`}</code>
        </div>
      </DemoSection.Item>
    </DemoSection>
  );
}
